/**
 * Token Storage
 *
 * sessionStorageによるCognito認証トークン管理。
 * Flutter WebViewからURLパラメータで受け取ったtokenを保存し、
 * React Router遷移中にtokenが消失してもAPI呼び出しで使用可能にする。
 */

const TOKEN_KEY = 'hk_auth_token';

export const tokenStorage = {
  /**
   * tokenをsessionStorageに保存
   * 空文字列は保存しない（hasToken=falseを防ぐため）
   */
  save: (token: string): void => {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, token);
    }
  },

  /**
   * sessionStorageからtokenを取得
   * 未保存時はundefinedを返す
   */
  get: (): string | undefined => {
    return sessionStorage.getItem(TOKEN_KEY) || undefined;
  },

  /**
   * sessionStorageからtokenを削除
   */
  clear: (): void => {
    sessionStorage.removeItem(TOKEN_KEY);
  },
};
